// extracted by mini-css-extract-plugin
export default {"input":"CNOption-input_Fyh6l"};